/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line



document.addEventListener('click', function (e) {
  const trigger = e.target.closest('[data-fullscreen-trigger]');
  const modal = document.getElementById('fullscreen-image-modal');
  if (!modal) return;

  if (trigger) {
    const img = modal.querySelector('.fullscreen-image-modal__img');
    img.src = trigger.dataset.fullscreenSrc;
    img.alt = trigger.dataset.fullscreenAlt || '';
    modal.hidden = false;
    document.body.style.overflow = 'hidden';
    return;
  }

  // клік по фону (не по картинці і не по кнопці close)
  if (e.target === modal || e.target.classList.contains('fullscreen-image-modal__inner')) {
    closeModal(modal);
  }
});

// окремий надійний обробник саме на close-кнопку
document.addEventListener('DOMContentLoaded', function () {
  const closeBtn = document.querySelector('.fullscreen-image-modal__close');
  if (closeBtn) {
    closeBtn.addEventListener('click', function () {
      closeModal(document.getElementById('fullscreen-image-modal'));
    });
  }
});

document.addEventListener('keydown', function (e) {
  const modal = document.getElementById('fullscreen-image-modal');
  if (e.key === 'Escape' && modal && !modal.hidden) {
    closeModal(modal);
  }
});

function closeModal(modal) {
  modal.hidden = true;
  document.body.style.overflow = '';
}



  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
